/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Gopay_Return_PendingInputs */

const cs_billing_gopay_return_pending = /** @type {(inputs: Billing_Gopay_Return_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platba ještě není hotová. Kredity se objeví po potvrzení GoPay.`)
};

const en_billing_gopay_return_pending = /** @type {(inputs: Billing_Gopay_Return_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment still pending. Credits will appear when GoPay confirms.`)
};

/**
* | output |
* | --- |
* | "Payment still pending. Credits will appear when GoPay confirms." |
*
* @param {Billing_Gopay_Return_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_gopay_return_pending = /** @type {((inputs?: Billing_Gopay_Return_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Gopay_Return_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_gopay_return_pending(inputs)
	return cs_billing_gopay_return_pending(inputs)
});